export enum ReservationTimeUnitEnum {
  HOUR = 'hour',
  DAY = 'day',
}

export enum ReservationConfirmationModeEnum {
  AUTO = 'auto',
  STAFF = 'staff',
}

export enum ReservationConfirmationDeadlineActionEnum {
  KEEP_PENDING = 'keep_pending',
  CANCEL = 'cancel',
}

export enum ReservationPaymentTypeEnum {
  NONE = 'none',
  SAVED_CARD = 'saved_card',
  DEPOSIT = 'deposit',
}

// Used by extra_charge_type, cancellation_fee_type and deposit_type
export enum ReservationFeeTypeEnum {
  FIXED = 'fixed',
  PER_GUEST = 'per_guest',
}

export enum ReservationNoShowFeeTypeEnum {
  NONE = 'none',
  FIXED = 'fixed',
  PER_GUEST = 'per_guest',
}

export enum ReservationDepositUseEnum {
  DEDUCT_FROM_BILL = 'deduct_from_bill',
  REFUND_AFTER_ATTENDANCE = 'refund_after_attendance',
  KEEP_AS_BOOKING_FEE = 'keep_as_booking_fee',
}

export enum ReservationDepositRefundPolicyEnum {
  REFUNDABLE_BEFORE_DEADLINE = 'refundable_before_deadline',
  NON_REFUNDABLE = 'non_refundable',
}

export enum ReservationNoShowRestrictionEnum {
  SAVED_CARD = 'saved_card',
  DEPOSIT = 'deposit',
}
